import * as React from "react";
import { ODataParams, Query } from "../../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import DocumentTitle from "../../../misc/components/DocumentTitle";
import { MipAnalysisListTable } from "./MipAnalysisListTable";
import { OverreadStatusIdEnum } from "../../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";

declare const window: any;

export const MipAnalysisListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getMipAnalysisSets('id,sessionId,created,started,status,type,analyst,analystId', filter, params.orderby, 'session($select=name,visit,challengeIsClosed,overreadChallengeStatus;$expand=visit($select=name,subject;$expand=subject($select=id,number,site;$expand=site($select=id,number))))', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="MIP Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh}
                initialFilters={[
                    { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                ]}
                initialOrdering={[{ field: "created", condition: "asc" }]}
            >
                <MipAnalysisListTable />
            </Query>
        </DocumentTitle>
    );
}
